<template>
  <div>
    <el-row>
      <el-col :span="18">
        <div class="block">
          <span class="demonstration">时间范围：</span>
          <el-date-picker
            v-model="timeRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <span class="demonstration" style="margin-left: 10px;"
            >门店类型：</span
          >
          <el-select v-model="shopType" placeholder="请选择" clearable="true">
            <el-option label="全部" value="''"></el-option>
            <el-option label="社区" value="社区"></el-option>
            <el-option label="酒店" value="酒店"></el-option>
            <el-option label="公寓" value="公寓"></el-option>
            <el-option label="校园" value="校园"></el-option>
          </el-select>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="m-ml10"
            @click="handleClick('orderCount')"
            >订单排名</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="条形图" name="first">
          <ve-bar
            :data="chartData"
            :settings="chartSettings"
            :height="chartheight"
          ></ve-bar>
        </el-tab-pane>

        <el-tab-pane label="表格数据" name="second">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="rank"
              label="排名"
              width="60"
            ></el-table-column>
            <el-table-column prop="shopName" label="店名" width="200">
            </el-table-column>
            <el-table-column prop="machineCount" label="机器数" width="80">
            </el-table-column>
            <el-table-column
              prop="orderCount"
              label="订单数"
              width="100"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="moneyCount"
              label="金额数"
              width="100"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="orderCountPerMachine"
              label="订单/机器"
              width="120"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="moneyCountPerMachine"
              label="金额/机器"
              width="120"
              sortable
            >
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    this.chartSettings = {
      dimension: ["门店"],

      metrics: ["订单", "金额"],
      stack: {
        xxx: ["订单", "金额"]
      },
      dataOrder: {
        label: "订单",
        order: "desc"
      }
    };
    return {
      shopType: "",
      activeName: "first",
      orderBy: "",
      timeRange: [moment().subtract(1, "days"), moment()],
      tableData: [],
      chartheight: "100px",
      chartData: {
        columns: ["门店", "订单", "金额"],
        rows: [
          // { 门店: "1/1", 订单: 1393, 金额: 1093 }
        ]
      }
    };
  },
  methods: {
    getWidth(data, dataType) {
      if (this.tableData && this.tableData.length > 0) {
        let first = this.tableData[0];
        return (100 * data) / first[dataType];
      }
      return 0;
    },
    format() {
      return "";
    },
    handleClick(orderBy) {
      console.log(this.shopType);
      this.orderBy = orderBy;
      this.$axios(this.$urlMapping["查询门店排名"], {
        data: {
          orderBy: orderBy,
          from: this.$ToDateString(this.timeRange[0]),
          to: this.$ToDateString(this.timeRange[1])
        }
      }).then(result => {
        console.log(result);
        if (this.shopType != "") {
          result = result.filter(
            x => x.shopDescription.indexOf(this.shopType) > -1
          );
        }

        this.tableData = result;
        //转换数据格式
        let rows = result.map(x => {
          return { 门店: x.shopName, 订单: x.orderCount, 金额: x.moneyCount };
        });
        this.chartData.rows = rows;
        console.log(this.chartData.rows);

        this.chartheight = rows.length * 20 + "px";
        console.log(this.chartheight);
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
